import {Role} from "@leap4/auth";

export const baseBackendRoute = process.env.REACT_APP_BACKEND_BASE_URL;
export const BACKEND_SERVICE_NAME = "Advertiser Login";
export const logoutUrl = baseBackendRoute + "/app/logout";
export const requiredAuthRoles: Role[] = [Role.USER];
export const meMultiUrl = baseBackendRoute + "/app/me_multi"
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const homeUrl = baseBackendRoute + "/home"
export const reportUrl = homeUrl + "/report"
export const homeOverviewUrl = homeUrl + "/overview"
export const homeOverviewSKIP_DISCUrl = homeUrl + "/overviewSkipDisc"
export const homeOverviewGraphUrl = homeOverviewUrl + "/graph"
export const advertiserLoginsUrl = homeUrl + "/advertiserLogins"

export enum DATES {
    TODAY = "today",
    YESTERDAY = "yesterday",
    LAST_SEVEN_DAYS = "last 7 days",
    LAST_THIRTY_DAYS = "last 30 days",
    LAST_MONTH = "last month",
    MTD = "mtd",
    CUSTOM = "custom"
}


export type OptionalDays = 1 | 7 | 28 | 30
export type DaysType = {
    [T:string]:{label:'-1' | '-7' | '-28'|'-30',value:OptionalDays}
}

export const DAYS: DaysType = {
    SEVEN: {label: '-7', value: 7},
    TWENTY_EIGHT: {label: '-28', value: 28},
    FULL_MONTH_AGO: {label: '-30', value: 30}
}

export const DATE_FORMAT = "yyyy-MM-dd"


